/** Sélecteur société — logo + nom + flèche + nouvelle société. */
import { Fragment, useEffect, useRef, useState } from "react";
import { CompanyCreateModal } from "../company/CompanyCreateModal";
import { useCompany } from "../company/CompanyProvider";
import { IconChevron } from "./NavIcons";
import { CompanyMark } from "./CompanyMark";

type CompanySwitchProps = {
  slim: boolean;
  onOpenSettings: () => void;
};

export function CompanySwitch({ slim, onOpenSettings }: CompanySwitchProps) {
  const { companies, company, setCompanyId } = useCompany();
  const [open, setOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (!box.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="fx-co" ref={box}>
      <button
        type="button"
        className="fx-co__btn"
        aria-expanded={open}
        aria-label={company ? company.legal_name : "Société"}
        title={company?.legal_name}
        onClick={() => setOpen((v) => !v)}
      >
        <CompanyMark company={company} />
        <span className="fx-co__name">{company?.legal_name || "Société"}</span>
        <IconChevron className="fx-co__chev" />
      </button>
      {open ? (
        <div className={`fx-co__menu${slim ? " fx-co__menu--slim" : ""}`} role="listbox" aria-label="Sociétés">
          {companies.map((c, i) => (
            <Fragment key={c.id}>
              {i > 0 ? <div className="fx-co__sep" aria-hidden /> : null}
              <button
                type="button"
                role="option"
                aria-selected={c.id === company?.id}
                className={c.id === company?.id ? "is-on" : ""}
                onClick={() => {
                  setCompanyId(c.id);
                  setOpen(false);
                }}
              >
                <CompanyMark company={c} />
                <span>{c.legal_name}</span>
              </button>
            </Fragment>
          ))}
          {companies.length > 0 ? <div className="fx-co__sep" aria-hidden /> : null}
          <button
            type="button"
            className="fx-co__add"
            onClick={() => {
              setOpen(false);
              setCreateOpen(true);
            }}
          >
            + Nouvelle société
          </button>
        </div>
      ) : null}
      <CompanyCreateModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onDone={onOpenSettings}
      />
    </div>
  );
}
